import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Navigate, generatePath, useNavigate } from 'react-router-dom';

import { Button, IconButton, Input } from '@treezor/design-system';

import { fetchSupportUserPairKey } from '@/store/actions/encryption.actions';
import { Header } from '@/ui-kit/header/Header';
import { useAppSelector, useAppDispatch } from '@/hooks/redux-helpers';
import { useCurrentSupportUser } from '@/features/dashboard-users/hooks/useCurrentSupportUser';
import { useRoutepaths } from '@/router/hooks/useRoutePaths';

interface IPassphraseForm {
  passphrase: string;
}

export const SupportEnterPassphrase = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const PathRoute = useRoutepaths();
  const [isVisible, setVisible] = useState<boolean>(false);
  const { isAuthenticated } = useCurrentSupportUser();

  const supportUserPairKey = useAppSelector((state) => state.encryption.supportUserPairKey);

  useEffect(() => {
    if (supportUserPairKey) {
      navigate(generatePath(PathRoute.auth.root, { '*': PathRoute.auth.signIn }));
    }
  }, [navigate, supportUserPairKey, PathRoute.auth.root, PathRoute.auth.signIn]);

  const { register, handleSubmit } = useForm<IPassphraseForm>();

  const isLoading = useAppSelector((state) => state.encryption.isLoading);

  if (!isAuthenticated) return <Navigate to={generatePath(PathRoute.auth.root, { '*': PathRoute.auth.signIn })} />;

  const onSubmit = (values: IPassphraseForm) => {
    dispatch(fetchSupportUserPairKey(values.passphrase));
  };

  return (
    <div className="min-w-[100vw]">
      <Helmet title="Passphrase" />
      <div className="flex flex-1 h-[100vh] flex-col">
        <Header />

        <div className="flex flex-1 items-center justify-center bg-primary p-8">
          <form className="w-[30%] min-w-[320px]" onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col w-full gap-4">
              <Input
                type={isVisible ? 'text' : 'password'}
                label={t('pages.auth.support.form.passphrase')}
                required
                icon={{
                  right: (
                    <IconButton
                      size="s"
                      variant="tertiary"
                      icon={isVisible ? 'visibility_off' : 'visibility'}
                      onClick={() => setVisible((value) => !value)}
                    />
                  ),
                }}
                {...register('passphrase')}
              />

              <Button id="support-enter-passphrase-btn" isLoading={isLoading} type="submit" className="w-full">
                {t('pages.auth.support.form.enterBtn')}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
